import i18n from '@/services/i18n'
import {
  PolicyAuditStateEnum,
  PolicyAuditTypeEnum,
  PolicyConditionTypeEnum,
  PolicyItemModel,
} from '@/constants/enum'
import { RSA_KEY_BEGIN, RSA_KEY_END } from '@/constants'

const { t } = i18n
export const getconditionText = (item: PolicyItemModel) => {
  switch (item.conditionType) {
    case PolicyConditionTypeEnum.VALUE_GREATER:
      return `${t('policy.sendValue')} ≥ ${item.amount} USD`
    case PolicyConditionTypeEnum.NUMBER_GREATER:
      return `${t('policy.sendNum')} ≥ ${item.amount} ${item.coinKey}`
    case PolicyConditionTypeEnum.VALUE_LESS:
      return t('policy.sendValueAnd24hours', {
        amount: item.amount,
        count: item.transferNumHour24 as any,
      })

    case PolicyConditionTypeEnum.NUMBER_LESS:
      return t('policy.sendNumAnd24hours', {
        amount: item.amount,
        unit: item?.coinKey,
        count: item.transferNumHour24 as any,
      })
    case PolicyConditionTypeEnum.VALUE_TIME:
      return t('policy.sendValueAndAccumulate24hours', {
        amount: item.amount,
        count: item.transferNumHour24 as any,
      })
    default:
      return ''
  }
}
export const getAuditStateText = (
  auditStatus: PolicyAuditStateEnum,
  applyType?: PolicyAuditTypeEnum
) => {
  if (auditStatus === PolicyAuditStateEnum.INIT) {
    return i18n.t('policy.notSubmit')
  }
  if (auditStatus === PolicyAuditStateEnum.CANCELLED) {
    return i18n.t('enum.txStatus.Cancelled')
  }
  const isDel = applyType === PolicyAuditTypeEnum.DEL
  if (auditStatus === PolicyAuditStateEnum.PENDING) {
    return `${isDel ? i18n.t('common.delete') : ''}${i18n.t('policy.pending')}`
  }
  if (auditStatus === PolicyAuditStateEnum.REJECT) {
    return `${isDel ? i18n.t('common.delete') : ''}${i18n.t('policy.reject')}`
  }
  return i18n.t('policy.passed')
}
export async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text)
  } catch (err) {
    console.log(err)
  }
}

export function checkIsPrivateKey(keyStr: string) {
  return keyStr?.startsWith('-----BEGIN PRIVATE KEY-----')
}
export function formatRSAPubKey(pubkey: string) {
  return pubkey?.replace(RSA_KEY_BEGIN, '').replace(RSA_KEY_END, '').replaceAll('\n', '').trim()
}
